import React from "react";
import LoadingButton from "./LoadingButton";
import { useBcomeVersionMap } from "../../../components/DbVersion";
import VersionSkeleton from "../../../components/VersionSkeleton";
import "./BackupRecoverySection.css";

const BackupRecoverySection = ({ record, downloadBackup, recoverBackup, loadingDownload, loadingRecover, hasBackup, backups }) => {
  const bcomeVersionMap = useBcomeVersionMap();
  const isLoadingVersion =
    !!record.bcomeVersionId && !bcomeVersionMap[record.bcomeVersionId];
  const versionLabel =
    bcomeVersionMap[record.bcomeVersionId] || record.version || "N/A";
  // Obtener la fecha del backup más reciente
  const getLastBackupDate = () => {
    if (!backups || backups.length === 0) return null;

    const latestBackup = backups[0];
    // Usar la fecha de creación del backup
    const backupDate = latestBackup.createdAt;

    return backupDate ? new Date(backupDate).toLocaleDateString('es-ES') : null;
  };

  const lastBackupDate = getLastBackupDate();

  return (
    <>
      <div className="backup-recovery-section__divider"></div>

      <div className="backup-recovery-section">
        <h3 className="backup-recovery-section__title">Backup recovery</h3>
        <div className="backup-recovery-section__content">
          <div className="backup-recovery-section__field">
            <strong className="backup-recovery-section__label">Last backup date</strong>
            <div className="backup-recovery-section__value">
              {lastBackupDate || "N/A"}
            </div>
          </div>
          <div className="backup-recovery-section__field">
            <strong className="backup-recovery-section__label">Version</strong>
            <div className="backup-recovery-section__value">
              {isLoadingVersion ? <VersionSkeleton /> : versionLabel}
            </div>
          </div>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (!loadingDownload && hasBackup) {
                downloadBackup(record);
              }
            }}
            className={`backup-recovery-section__download-link ${loadingDownload ? 'backup-recovery-section__download-link--loading' : ''} ${!hasBackup ? 'backup-recovery-section__download-link--disabled' : ''}`}
          >
            {loadingDownload ? 'Downloading...' : 'Download'}
          </a>
          <div>
            <LoadingButton
              color="primary"
              variant="contained"
              onClick={recoverBackup}
              loading={loadingRecover}
              disabled={!hasBackup}
            >
              Recover
            </LoadingButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default BackupRecoverySection;
